'use client'

import { useRef, useState, useEffect } from 'react';
import { useIntersection } from 'react-use';

interface FadeInOnVisibleProps {
    children: React.ReactNode;
    className?: string;
    delay?: number;
}

const FadeInOnVisible: React.FC<FadeInOnVisibleProps> = ({ children, className = '', delay = 0 }) => {
    const ref = useRef<HTMLDivElement>(null) as any
    const intersection = useIntersection(ref, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
    });

    const [hasBeenVisible, setHasBeenVisible] = useState(false);

    useEffect(() => {
        if (intersection?.isIntersecting && !hasBeenVisible) {
            setHasBeenVisible(true);
        }
    }, [intersection, hasBeenVisible]);

    return (
        <div
            ref={ref}
            className={className}
            style={{
                opacity: hasBeenVisible ? 1 : 0,
                transform: hasBeenVisible ? 'translateY(0)' : 'translateY(20px)',
                transition: `opacity 0.6s ease-out ${delay}s, transform 0.6s ease-out ${delay}s`,
            }}
        >
            {children}
        </div>
    );
};

export default FadeInOnVisible;
